import { useState } from 'react';

export default function NumberInput(props) {
  const [value, setValue] = useState(props.value || 0);
  const { className, name, onChange, ...rest } = props;

  const decrement = () => {
    let val = parseInt(value) - 1;
    val = validateValue(val);
    setValue(val);
    onChange(val);
  };

  const increment = () => {
    let val = parseInt(value) + 1;
    val = validateValue(val);
    setValue(val);
    onChange(val);
  };

  const validateValue = (val) => {
    if (!isNaN(parseInt(props.min))) {
      val = val < props.min ? props.min : val;
    }

    if (!isNaN(parseInt(props.max))) {
      val = val > props.max ? props.max : val;
    }

    return val;
  };

  const handleChange = (e) => {
    let val = validateValue(e.target.value);
    setValue(val);
    onChange(val);
  };

  return (
    <div className={`${className} custom-number-input h-6 w-24`}>
      <div className="relative flex h-8 w-full flex-row rounded border bg-transparent">
        <button
          className="text-gray-60 h-full w-20 cursor-pointer border-r outline-none"
          onClick={decrement}
        >
          <span className="m-auto block align-middle text-sm font-medium">
            −
          </span>
        </button>
        <input
          type="number"
          value={value}
          name={name}
          onChange={handleChange}
          className="md:text-basecursor-default text-gray-70 flex w-full items-center border-0 p-0  text-center text-sm font-medium hover:text-black focus:text-black"
          {...rest}
        />
        <button
          className="h-full w-20 cursor-pointer  border-l text-gray-600"
          onClick={increment}
        >
          <span className="m-auto block text-sm font-medium">+</span>
        </button>
      </div>
    </div>
  );
}
